import React, { useEffect } from 'react';
import { reaction } from 'mobx';
import { REACT_APP_ENVIRONMENT } from '@partsbadger/utils';

import UserStore from '../../stores/UserStore';
import { clearPortalVisitorIdentity, identifyPortalVisitor } from '../../utils/identifyPortalVisitor';
import { isLuckyOrangeEnabled, LUCKY_ORANGE_SITE_ID } from '../../utils/luckyOrange';

const LuckyOrangeIntegration = () => {
    useEffect(() => {
        if (!isLuckyOrangeEnabled()) {
            return;
        }

        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = `https://tools.luckyorange.com/core/lo.js?site-id=${LUCKY_ORANGE_SITE_ID}`;
        document.body.appendChild(script);

        const disposeIdentityReaction = reaction(
            () => ({
                user: UserStore.user,
                guestEmail: UserStore.guest_email,
                isAuthenticated: UserStore.isAuthenticated,
            }),
            ({ user, guestEmail, isAuthenticated }) => {
                if (isAuthenticated && user?.id) {
                    identifyPortalVisitor(user, guestEmail);
                    return;
                }

                if (guestEmail?.trim()) {
                    identifyPortalVisitor(null, guestEmail);
                    return;
                }

                clearPortalVisitorIdentity();
            },
            { fireImmediately: true }
        );

        return () => {
            disposeIdentityReaction();
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

    return null;
};

export default LuckyOrangeIntegration;
